module.exports = __webpack_public_path__ + "media/images/apple-touch-icon-114x114-0af83d5735ba9bcb369106dcc7fffe06.png";